import {
  Box,
  Divider,
  Group,
  Select,
  SimpleGrid,
  Stack,
  Text,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import {
  CRITERIA_KIND,
  CRITERIA_TYPES,
  GROUP_POST_KEYS,
  SELECT_POST_KEYS,
  toBackendValue,
  TYPE_LABEL_KEYS,
} from "../constants";

const SelectGroupSection = ({
  kind,
  options,
  ownValue,
  otherValue,
  onChange,
}) => {
  const { t } = useTranslation();
  const isSelect = kind === CRITERIA_KIND.SELECT;
  const postKeys = isSelect ? SELECT_POST_KEYS : GROUP_POST_KEYS;

  const handleChange = (type, val) => {
    if (val === null) {
      onChange(ownValue.filter((e) => e.type !== type));
      return;
    }

    const item = options[type].find((o) => o.value === val);
    if (!item) return;

    const entry = {
      type,
      selected: val,
      value: val === "ALL" ? [] : [toBackendValue(type, val)],
      label: item.label,
      postValueType: postKeys[type],
    };

    const next = [...ownValue];
    const i = next.findIndex((e) => e.type === type);
    if (i === -1) next.push(entry);
    else next[i] = entry;
    onChange(next);
  };

  const filledCount = ownValue.length;

  return (
    <Stack gap="md" w="100%" style={{ flex: 1 }}>
      <Stack gap="xs">
        <Group gap="xs" align="center">
          <Box w={3} h={20} bg="primary.7" style={{ borderRadius: 2 }} />
          <Text size="sm" fw={600} tt="uppercase" c="secondary.9" lts={1}>
            {t(isSelect ? "auditTrail.select" : "auditTrail.groupBy")}
          </Text>
          {filledCount > 0 && (
            <Text size="sm" c="dimmed">
              ({filledCount})
            </Text>
          )}
        </Group>
        <Divider color="gray.3" />
      </Stack>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="sm">
        {CRITERIA_TYPES.map((type) => (
          <Select
            key={type}
            label={t(TYPE_LABEL_KEYS[type])}
            placeholder=""
            data={options[type] ?? []}
            value={ownValue.find((e) => e.type === type)?.selected ?? null}
            disabled={otherValue.some((e) => e.type === type)}
            onChange={(val) => handleChange(type, val)}
            clearable
          />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default SelectGroupSection;
